import axios from 'axios';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
});

apiClient.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem('authToken') || localStorage.getItem('token');

        if (!token || token === 'undefined' || token === 'null') {
            try {
                const sessionStr = localStorage.getItem('visitorUser') || localStorage.getItem('userInfo');
                if (sessionStr) {
                    const parsed = JSON.parse(sessionStr);
                    token = parsed?.token || parsed?.user?.token || parsed?.user?.user?.token;
                }
            } catch (e) {
                // Ignore parse errors
            }
        }

        if (token && token !== 'undefined' && token !== 'null') {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        // 401 handling is now managed globally in axiosGlobalConfig.js
        return Promise.reject(error);
    }
);

export default apiClient;